import { useState, useMemo } from "react";
import { useTheme } from "styled-components";
import { useSupportedBrokers } from "features/Dashboard/hook/useSupportedBrokers";
import { ListItem } from "components/ListItem";
import { Loader } from "components/Loader";
import { getBrokerIcon } from "utils/index";
import PropTypes from "prop-types";
import {
  BrokerListContainer,
  InputSearchWrapper,
  SearchInput,
  SearchIconWrapper,
} from "./SupportedBrokers.styles";
import { ClearSearchButton } from "./SupportedBrokers.styles";
import { SearchIconV2 } from "assets/icons";

const SupportedBrokers = ({ onBrokerSelect, listHeight, fromSignup }) => {
  const theme = useTheme();
  const { isLoading, brokers } = useSupportedBrokers();
  const [searchValue, setSearchValue] = useState("");

  const filteredBrokers = useMemo(() => {
    if (searchValue && brokers.length) {
      return brokers.filter((item) =>
        item.display_name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    if (fromSignup) {
      return brokers.filter((item) => item.slug !== "SURMOUNT-PAPER");
    }

    return brokers;
  }, [searchValue, brokers]);

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const clearSearch = () => {
    setSearchValue("");
  };

  if (isLoading) return <Loader />;

  return (
    <>
      <InputSearchWrapper>
        <SearchIconWrapper>
          <SearchIconV2 className="search-icon" />
        </SearchIconWrapper>
        <SearchInput
          value={searchValue}
          onChange={handleSearch}
          placeholder="Search any broker"
        />
        {searchValue && (
          <ClearSearchButton onClick={clearSearch}>×</ClearSearchButton>
        )}
      </InputSearchWrapper>
      <BrokerListContainer $listHeight={listHeight}>
        {filteredBrokers.map((broker, idx) => (
          <ListItem
            key={broker.key || broker.display_name || idx}
            brokerLogo={getBrokerIcon(broker.square_logo_url, theme.mode)}
            broker={broker.display_name}
            brokerKey={broker.key}
            brokerUrl={broker.url}
            eligible={broker.can_trade}
            eligibleMessage={
              broker.can_trade ? undefined : "Trading not yet supported"
            }
            onClick={() => onBrokerSelect && onBrokerSelect(broker)}
            showDivider={true}
          />
        ))}
      </BrokerListContainer>
    </>
  );
};

SupportedBrokers.propTypes = {
  onBrokerSelect: PropTypes.func,
  listHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fromSignup: PropTypes.bool,
};

export default SupportedBrokers;
